import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import Step from './Step/Step.js';

const getStatus = (active, index, skip)=>{
    if (active === index) {
        return 'active';
    } else if (skip) {
        return 'skip';
    } else if (active > index) {
        return 'done';
    } else {
        return 'open';
    }
};
const WizardProgress = (_param)=>{
    var { className , steps , active , withSeparators =false , labelStyle , onClick , skipSteps , disableSteps  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "steps",
        "active",
        "withSeparators",
        "labelStyle",
        "onClick",
        "skipSteps",
        "disableSteps"
    ]);
    return /*#__PURE__*/ React__default.createElement("ol", swcHelpers.extends({}, rest, {
        className: classnames('wizard-progress', className, {
            'wizard-progress--with-inline-labels': labelStyle === 'inline',
            'wizard-progress--with-separators': withSeparators && labelStyle !== 'inline'
        })
    }), steps.map((step, index)=>{
        const isSkip = skipSteps === null || skipSteps === void 0 ? void 0 : skipSteps.includes(index);
        const isDisabled = disableSteps === null || disableSteps === void 0 ? void 0 : disableSteps.includes(index);
        return /*#__PURE__*/ React__default.createElement("li", {
            className: "wizard-progress__item",
            key: step
        }, /*#__PURE__*/ React__default.createElement(Step, {
            index: index,
            number: index + 1,
            label: step,
            className: classnames({
                'wizard-progress__step--with-spacing': !withSeparators && labelStyle === 'hidden'
            }),
            disabled: isSkip || isDisabled || false,
            hideLabel: labelStyle === 'hidden',
            status: getStatus(active, index, isSkip || false),
            onClick: onClick,
            "data-t": `wizardStep${index + 1}`
        }));
    }));
};
var WizardProgress$1 = WizardProgress;

export { WizardProgress$1 as default };
//# sourceMappingURL=WizardProgress.js.map
